export default __webpack_public_path__ + "static/media/biofit-builder-series-2A.197c3719.png";